import { gql } from '@apollo/client';

export const UPDATE_GAME_STATE = gql`
    subscription updatedGameState($url: String!) {
        updatedGameState(url: $url)
    }
`;